export function akamaiGetDevice(
  headers: Record<string, string | string[]> = {}
) {
  const isTabletHeader = headers["tablet-device"];
  const isMobileHeader = headers["mobile-device"];

  let device: "desktop" | "tablet" | "mobile" = "desktop";

  switch ("true") {
    case isTabletHeader:
      device = "tablet";
      break;
    case isMobileHeader:
      device = "mobile";
      break;
    default:
      device = "desktop";
      break;
  }
  return device;
}

export const akamaiDCparser = (header: string | undefined) => {
  const separator = ";";
  if (!header) {
    return {};
  }
  try {
    const akamaiDCHeader = Object.fromEntries(
      header
        .split(separator)
        .map((v) => v.split(/=(.*)/).map(decodeURIComponent))
    );
    return akamaiDCHeader;
  } catch (e) {
    return {};
  }
};
